<template>
  <div>
    <v-navigation-drawer
      class="hidden-md-and-up dark-mobile-menu"
      v-model="drawer"
      absolute
      temporary
      width="320"
      dark
    >
      <div class="mobile-header">
        <div class="logo">
          <img
            src="/logoCodetimeWhite.webp"
            alt="brand-image"
          />
        </div>
        <v-btn
          class="close-icon"
          icon
          @click="drawer = !drawer"
          v-html="iconSvg(closeIcon)"
        >
        </v-btn>
      </div>

      <v-list class="mobile-menu-list">
        <!-- Menu mobile simplificado com os mesmos itens do desktop -->
        <v-list-item
          :ripple="false"
          @click="scrollToSection('portfolio'); drawer = false"
          link
          class="mobile-menu-item"
        >
          <v-list-item-content>
            <v-list-item-title>Projetos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :ripple="false"
          @click="scrollToSection('service'); drawer = false"
          link
          class="mobile-menu-item"
        >
          <v-list-item-content>
            <v-list-item-title>Soluções</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :ripple="false"
          @click="scrollToSection('about'); drawer = false"
          link
          class="mobile-menu-item"
        >
          <v-list-item-content>
            <v-list-item-title>Sobre</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :ripple="false"
          @click="scrollToSection('contact'); drawer = false"
          link
          class="mobile-menu-item"
        >
          <v-list-item-content>
            <v-list-item-title>Contato</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :ripple="false"
          to="/blog"
          link
          class="mobile-menu-item"
          @click="drawer = false"
        >
          <v-list-item-content>
            <v-list-item-title>Blog</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- WhatsApp no menu mobile - botão igual ao desktop -->
        <div class="mobile-whatsapp-container">
          <a 
            class="btn-default cta-whatsapp mobile-whatsapp" 
            target="_blank" 
            rel="noopener" 
            :href="whatsLink" 
            aria-label="Falar com Especialista"
            @click="drawer = false"
          >
            <!-- <i class="mdi mdi-whatsapp"></i> -->
            <span class="cta-text">Falar com Especialista</span>
          </a>
        </div>
      </v-list>
    </v-navigation-drawer>
    <!-- End sidebar mobile menu -->

    <v-app-bar
      dark
      elevation="0"
      color="transparent"
      absolute
      class="default-header"
      style="justify-content: space-between; padding: 0 16px;"
    >
      <router-link to="/" class="logo">
        <slot name="logo"></slot>
      </router-link>
      <!-- End brand logo -->

      <!-- Navegação desktop -->
      <div class="header-navigation hidden-sm-and-down">
        <v-toolbar-items class="hidden-xs-only hidden-sm-only height-auto" style="display: flex; align-items: center;">
          <v-btn :ripple="false" text to="/">Início</v-btn>
          <v-btn :ripple="false" text @click="scrollToSection('portfolio')">Projetos</v-btn>
          <v-btn :ripple="false" text @click="scrollToSection('service')">Serviços</v-btn>
          <v-btn :ripple="false" text @click="scrollToSection('about')">Sobre</v-btn>
          <v-btn :ripple="false" text @click="scrollToSection('contact')">Contato</v-btn>
          <v-btn :ripple="false" text to="/blog">Blog</v-btn>
        </v-toolbar-items>
        <a class="btn-default cta-whatsapp" target="_blank" rel="noopener" :href="whatsLink" aria-label="Falar com Especialista">
          <!-- <i class="mdi mdi-whatsapp"></i> -->
          <span class="cta-text">Falar com Especialista</span>
        </a>
      </div>

      <!-- Elementos mobile -->
      <div class="mobile-elements hidden-md-and-up">
        <v-btn :ripple="false" icon class="ma-0 pa-0 menu_icon" @click="drawer = !drawer" v-html="iconSvg(icon)"></v-btn>
        <a class="btn-default cta-whatsapp mobile-whatsapp" target="_blank" rel="noopener" :href="whatsLink" aria-label="Falar com Especialista">
          <!-- <i class="mdi mdi-whatsapp"></i> -->
          <span class="cta-text">Falar com Especialista</span>
        </a>
      </div>
    </v-app-bar>
    <!-- End top header navbar -->
  </div>
</template>

<script>
  import feather from "feather-icons";
  export default {
    props: {
      whatsLink: {
        type: String,
        default: 'https://wa.me/5547933807051'
      }
    },
    data: () => ({
      drawer: false,
      icon: "menu",
      closeIcon: "x",
    }),

    methods: {
      iconSvg(icon) {
        return feather.icons[icon].toSvg();
      },
      
      scrollToSection(sectionId) {
        // Se não estamos na página principal, redirecionar para home com âncora
        if (this.$route.path !== '/') {
          this.$router.push(`/#${sectionId}`);
        } else {
          // Na página principal, fazer scroll para a seção
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      },
      openWhatsApp() {
        window.open(this.whatsLink, '_blank');
      }
    },
  };
</script>

<style scoped>
/* Estilos para o menu mobile dark */
.dark-mobile-menu {
  background: #1a1a1a !important;
}

/* Header do menu mobile */
.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.mobile-header .logo img {
  max-height: 36px;
  height: 36px;
}

/* Estilo para o botão de fechar */
.dark-mobile-menu .close-icon {
  color: rgba(255, 255, 255, 0.7) !important;
  background: transparent;
  width: 32px;
  height: 32px;
}

.dark-mobile-menu .close-icon:hover {
  color: white !important;
  background: rgba(255, 255, 255, 0.05) !important;
}

/* Lista do menu mobile */
.mobile-menu-list {
  padding: 8px 0;
}

/* Remover padding desnecessário do Vuetify */
.v-navigation-drawer--is-mobile .v-list-item__content {
  padding: 0 !important;
}

/* Remover min-height desnecessário */
.v-navigation-drawer--is-mobile .v-list-item {
  min-height: auto !important;
}

/* Estilos específicos para mobile */
.mobile-menu-item {
  padding: 16px 24px !important;
  margin: 0;
  border-radius: 0;
  border: none !important;
  transition: background-color 0.2s ease;
  background: transparent;
}

.mobile-menu-item:hover {
  background: rgba(255, 255, 255, 0.03) !important;
}

.mobile-menu-item .v-list-item__title {
  font-size: 16px !important;
  font-weight: 400 !important;
  color: rgba(255, 255, 255, 0.9) !important;
  letter-spacing: 0.2px;
}

.mobile-whatsapp-container {
  margin: 24px 24px 20px 24px;
  padding: 0;
}

.mobile-whatsapp {
  width: 100%;
  justify-content: center;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  background: #25D366;
  border: none;
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: background-color 0.2s ease;
}

.mobile-whatsapp:hover {
  background: #128C7E;
}

.mobile-whatsapp .mdi-whatsapp {
  font-size: 18px;
  color: #25D366;
}

.mobile-whatsapp .cta-text {
  font-weight: 500;
  color: white;
  letter-spacing: 0.3px;
}

/* Estilo adicional para garantir que funcione */
.dark-mobile-menu .v-list-item {
  color: #FFFFFF !important;
}

.dark-mobile-menu .v-list-item * {
  color: #FFFFFF !important;
}

/* Classe para navegação do header */
.header-navigation {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Classe para elementos mobile */
.mobile-elements {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Garantir que o ícone do WhatsApp apareça */
.mdi-whatsapp {
  display: inline-block !important;
  font-size: 18px !important;
  color: #25D366 !important;
}

/* Regra mais específica para garantir que a cor seja aplicada */
.mdi-whatsapp[data-v-ed558de2] {
  color: #25D366 !important;
}

.mobile-whatsapp .mdi-whatsapp {
  margin-right: 8px !important;
}

/* Ajustes para o header no mobile */
@media (max-width: 959px) {
  .default-header {
    padding: 0 16px !important;
  }
  
  .logo img {
    max-height: 40px;
    height: 40px;
  }
  
  .menu_icon {
    padding: 8px !important;
    margin: 0 !important;
  }
  
  /* Ajustar tamanho do texto do botão WhatsApp no mobile */
  .contact-address-whatsapp-btn .cta-text {
    font-size: 1rem !important;
  }
}
</style>
